const escapeRegExp = (str: string) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const replaceAll = (str: string, find: any, replace: string) => {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
}

/**
 * Rich text authored in the admin stores a blank line as an empty paragraph. Tailwind's preflight
 * and Chakra's CSS reset strip paragraph margins, so an empty <p> collapses to zero height and the
 * blank line vanishes on the storefront. Give it a non-breaking space so it keeps its line box.
 */
export const preserveBlankLines = (html: string) => {
  return html.replace(/<p([^>]*)>\s*<\/p>/gi, '<p$1>&nbsp;</p>')
}

/** Whether admin-authored copy is markup or plain text, so each can be laid out on its own terms. */
export const containsHtml = (value: string) => {
  return /<[a-z][^>]*>/i.test(value)
}
